import { Fragment } from 'react';

import Gap from 'bloko/blocks/gap';
import InputText from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';
import ClickmeFormWrapper from 'components/ClickmeFormWrapper';

import { PayerCreateForm } from 'components/Admin/PayerCreate/PayerCreateForm';
import TitlePage from 'components/Admin/TitlePage';

import { setPayerUserId } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/PayerCreate/PayerCreate.less';

const PayerCreate = () => {
    const dispatch = useDispatch();
    const { payerUserId, payerErrors } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <Fragment>
            <TitlePage>{trl('admin.PayerCreate.title')}</TitlePage>
            <div className="admin-payer-create-form">
                <Gap top bottom>
                    <ClickmeFormWrapper>
                        <ClickmeFormItem
                            input={
                                <InputText
                                    value={payerUserId}
                                    onChange={(value) => dispatch(setPayerUserId(value))}
                                    placeholder={trl('admin.PayerCreate.UserId.placeholder')}
                                    invalid={Boolean(payerErrors.user)}
                                />
                            }
                            legend={trl('admin.PayerCreate.UserId.legend')}
                            isRequired
                            error={payerErrors.user}
                        />
                    </ClickmeFormWrapper>
                    <PayerCreateForm />
                </Gap>
            </div>
        </Fragment>
    );
};

export default PayerCreate;
